export default {
    duoterui:'doterra'
}


// WEBPACK FOOTER //
// ./src/easeCodeGlobal.js